//百度广告对应的container
export const tencentContainerMap = new Map([
    ["u6903284", "_7evw3hcc83o"],//网速课堂轮播图
    ["u6903283", "_o6s9yii1p1k"],//资讯右上侧
    ["u6903282", "_ewbhug24ipo"],//5g覆盖图右下侧
    ["u6903281", "_wgnbm5rkme"],//工具箱左侧2
    ["u6903280", "_fho5ckctohg"],//工具箱左侧1
    ["u6903279", "_4c0jchq94hk"],//更多工具便民工具右侧1
    ["u6903278", "_wfai2929tpr"],//更多工具便民工具右侧2
    ["u6903277", "_ctjhw1ljqkv"],//首页便民工具右侧2
    ["u6903276", "_wospdybnieg"],//首页便民工具右侧1
    ["u6900726", "_lns1bwh1n8"],//www首页左侧2
    ["u6900725", "_mgx97j7yv4c"],//www首页左侧1
    ["u6370117", "_ee53d0nwy8o"],//www5g页面顶部2
    ["u6370116", "_s4mvlz4dyu"],//www5g页面顶部1
    ["u6370115", "_qkpl1lirdt"],//www5g运营商下方2
    ["u6370114", "_e2haabkt27w"],//www5g运营商下方1
    ["u6370113", "_wjvmlqvlno"],//www5g地图下方2
    ["u6370112", "_rodw2dchs5"],//www5g地图下方1
    ["u6370110", "_p9pglyuohk"],//www5g设备下方2
    ["u6370109", "_5zbh5ztur6l"],//www5g设备下方1
    ["u6370108", "_e6fuctrgw45"],//www5g资讯下方2
    ["u6370107", "_duakcfg0sso"],//www5g资讯下方1
    ["u6370106", "_dnun1nziwj9"],//www5g页面右侧
    ["u6370105", "_bc4idvg6y4t"],//www5g页面左侧
    ["u6369363", "_oojmbx0o8z"],//www网络工具测速类右侧
    ["u6369362", "_gdk2nfgx2ln"],//www网络工具测速类左侧
    ["u6369117", "_j4udnoieqq"],//www网络工具首页面顶部2
    ["u6369116", "_xstjagdyh3m"],//www网络工具首页面顶部1
    ["u6369115", "_r37azumgwn"],//www网络工具测速类底部2
    ["u6369114", "_b73go59jzce"],//www网络工具测速类底部1
    ["u6369113", "_m0x171jt9f"],//wwwIp查询、号码归属地查询、ping测试右侧
    ["u6369112", "_0md55p80cy3g",],//wwwIp查询、号码归属地查询、ping测试左侧
    ["u6369111", "_ayjejmpppdh"],//www提速页面顶部2
    ["u6369110", "_tqraa2pgt1"],//www提速页面顶部1
    ["u6369109", "_gztfes7k2f"],//www提速页面右侧
    ["u6369107", "_efpwnzog43p"],//www提速页面左侧
    ["u6369106", "_84oreu9s51v"],//www首页测速资讯下横幅2
    ["u6369105", "_eipbp95w2bq"],//www首页测速资讯下横幅1
    ["u6369104", "_gtenpn0e39m"],//www首页测速结束网络应用场景下2
    ["u6369103", "_s31qspuvn48"],//www首页测速结束网络应用场景下1
    ["u6369102", "_o1fwgq7qxlb"],//www宽带提速上传上方2
    ["u6369101", "_ljwk3t08ixg"],//www宽带提速上传上方1
    ["u6369100", "_tqleqqb1ib"],//www宽带提速范围顶部2
    ["u6369098", "_3qhmuxn5sl3"],//www宽带提速范围顶部1
    ["u6369088", "_k01tv4f2dv"],//www宽带提速范围底部1
    ["u6369091", "_7pe5j8w9j4n"],//www宽带提速范围底部2
    ["u6369085", "_w8hlr2fsnhr"],//www宽带提速范围右侧
    ["u6369084", "_3kos1rs3nr5"],//www宽带提速范围左侧
    ["u6369083", "_u36wdnplh6o",],//www测速详情-网络知识顶部
    ["u6369082", "_d4n5q1z2x0v"],//www测速详情-网络知识底部
    ["u6369081", "_74xwaupm7qt"],//www诊断报告更多实用工具下方2
    ["u6369080", "_kdhqsnraghd"],//www诊断报告更多实用工具下方1
    ["u6369079", "_gv981qkwo3c"],// www诊断报告页面当前网速适用场景下方2
    ["u6369078", "_i93dcmd87xp"],// www诊断报告页面当前网速适用场景下方1
    ["u6369076", "_ozag9m492y"],// www诊断报告页面顶部2
    ["u6369075", "_x0ldo0aumd9"],// www诊断报告页面顶部1
    ["u6368947", "_etzzxihn7hd"],// www测速插件首屏右侧
    ["u6368946", "_tzjre99dg5"],// www测速插件首屏左侧
    ["u6368933", "_a4ou9va83m"],// www历史记录顶部
    ["u6368922", "_gcd8jnqkpc"],// www首页表盘下方右边
    ["u6368918", "_eevpqb5dd3u"],// www首页表盘下方左边
    ["u6368901", "_ygd10lyftpm"],// www首页底部2
    ["u6368899", "_ebsrjl0jga7"],// www首页底部1
    ["u6368898", "_op3kijmnba"],// www首页测速资讯下横幅2
    ["u6368897", "_2slpb46i9od"],//www首页测速资讯下横幅1
    ["u6368896", "_dh4ld52li6o"],// www首页便民工具上横幅2
    ["u6368895", "_wwynyt2jorm"],//www首页便民工具上横幅1
    ["u6368894", "_tj4fxo8tddb"],// www首页测速资讯上横幅2
    ["u6368888", "_esndr6u3znk"],// www首页测速资讯上横幅1
    ["u6368887", "_qmuiopb1sfa"],// www首页5G地图下横幅1
    ["u6368886", "_m5vzqyw70g"],// www首页5G地图下横幅2
    ["u6368885", "_2b0s5zp5yqb"],// www首页顶部右侧
    ["u6368884", "_9efia6myyon"],//www首页顶部左侧
    ["u6368883", "_ous58vi80jn"],// www首页右侧
    ["u6368575", "_3s16mom1bpp"],//www首页左侧
    ["u6368573", "_qpg25i7yarc",],//www网速知识表格上方
    ["u6368556", "_isqzpntun4n"],// www网速知识ping介绍上方
    ["u6368526", "_1t5rw8cixd2"],//www网速知识底部2
    ["u6368442", "_iae2znoqcwk"],//www网速知识底部1
    ["u6368344", "_qbchrby1and"],//www网速知识右侧
    ["u6368343", "_n7psj6io7r"],//www网速知识左侧
    ["u6368342", "_auezzt189qa"],//www资讯详情顶部
    ["u6368340", "_3orwpiqnsms"],//www资讯详情底部
    ["u6368338", "_495awx4k0ew"],//www咨询文章广告位2
    ["u6368336", "_en7qu6ydivu"],//www咨询文章广告位1
    ["u6368218", "_hl5ljff6qj5"],//www网速知识顶部2
    ["u6368189", "_nl349tbhdqr"],//www网速知识顶部1
    ["u6911435", "_5cybdn6o9o9"], // www首页附近网速入口
    ["u6911436", "_qm9jnh6lm2c"], // www测速历史记录附近网速入口
])



// WEBPACK FOOTER //
// ./resources/js/config/tencentContainerMap.js